import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube } from "lucide-react";
import { SERVICES } from "../data/content";
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_DISPLAY } from "../config";
import { LogoMark } from "./Header";
import { BookingButton } from "./Cta";

export default function Footer() {
  return (
    <footer className="footer" data-testid="site-footer">
      <img src="/logo-oasis-white.png" alt="" aria-hidden="true" className="footer-word-img" />
      <div className="footer-grid">
        <div className="footer-brand">
          <span className="brand">
            <img src="/logo-oasis-white.png" alt="Oasis Business Solutions" className="brand-logo footer-logo" />
          </span>
          <p>Product branding &amp; packaging design studio in Pune. Film, identity, packaging, social and web — made to be felt.</p>
          <div className="footer-social">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram-link">
              <Instagram size={17} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin-link">
              <Linkedin size={17} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="footer-youtube-link">
              <Youtube size={17} />
            </a>
          </div>
        </div>
        <div>
          <h4>Studio</h4>
          <Link to="/" data-testid="footer-home-link">Home</Link>
          <Link to="/work" data-testid="footer-work-link">Work</Link>
          <Link to="/journal" data-testid="footer-journal-link">Journal</Link>
          <Link to="/about" data-testid="footer-about-link">About</Link>
          <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
        </div>
        <div>
          <h4>Services</h4>
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`}>
              {s.name}
            </Link>
          ))}
        </div>
        <div>
          <h4>Start something</h4>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link">
            {CONTACT_EMAIL}
          </a>
          <a href={`tel:${CONTACT_PHONE}`} data-testid="footer-phone-link">
            {CONTACT_PHONE_DISPLAY}
          </a>
          <div className="footer-booking">
            <BookingButton testid="footer-booking-button" />
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Oasis Business Solutions</span>
        <span>Pune, India · Working worldwide</span>
      </div>
    </footer>
  );
}
